import { Form, Formik } from 'formik';
import { useEffect } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../../Components/Input/Input';
import ajclWhiteLogo from "../../../images/ajcl_logo_white.png";
import { loginUser } from '../../../Redux/Action/Auth';
import { errorNotify } from '../../../Utils/Toast';
import { loginSchema } from '../../../Utils/Validations';
import './Login.css';
import { getUserDetail } from '../../../Utils/Helper';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { loading, loginApiData, error } = useSelector((state) => state.auth);

    useEffect(() => {
        const token = localStorage.getItem('tmsToken');
        if (token) {
            if (getUserDetail()?.role === 'user') {
                navigate('/dashboard/interested-tenders');
            }
            else {
                navigate('/dashboard');
            }
        }
    }, [navigate]);

    useEffect(() => {
        if (loginApiData?.token) {

            if (loginApiData?.user_details?.role === 'user') {
                navigate('/dashboard/interested-tenders');
            }
            else {
                navigate('/dashboard');
            }

            dispatch({ type: "LOGIN_RESET" });
        }
        else if (error) {
            errorNotify(error);
            dispatch({ type: "LOGIN_RESET" });
        }
    }, [loginApiData, navigate, error]);

    return (
        <div className='login_wrapper'>
            <Container fluid>
                <Row>
                    <Col md={6} className='login_left_side'>
                        <div>
                            <img src={ajclWhiteLogo} alt="logo" className='main_logo' />
                            <h1>Tender Management System</h1>
                        </div>
                    </Col>
                    <Col md={6} className='login_right_side'>
                        <div className='login_form_wrapper'>
                            <div className='login_form_heading'>
                                <h2>Login</h2>
                                <p>Welcome back! Please enter your details.</p>
                            </div>

                            <Formik
                                initialValues={{
                                    email: '',
                                    password: '',
                                }}
                                validationSchema={loginSchema}
                                onSubmit={(values) => {
                                    dispatch(loginUser(values));
                                }}
                            >
                                {() => (
                                    <Form>
                                        <div className='login_form_fields'>
                                            <Input
                                                type="text"
                                                name="email"
                                                placeholder="Enter your email"
                                                label="Email"
                                            />
                                            <Input
                                                type="password"
                                                name="password"
                                                placeholder="Enter your password"
                                                label="Password"
                                            />
                                            <div className='auth_links forgot_password'>
                                                <Link to="/forgot-password">Forgot Password?</Link>
                                            </div>
                                            <button
                                                type="submit"
                                                disabled={loading}
                                                className='login_btn mt-0'
                                            >
                                                {loading ? <Spinner animation='border' size='sm' /> : 'Login'}
                                            </button>
                                        </div>
                                        <div className='auth_links'>
                                            <p>Don't have an account? <Link to="/signup">Create Now</Link></p>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Login;